import React, { useState, useEffect } from "react";
import axios from "axios";

import FiltrosDesktop from "./FiltrosDesktop";
import FiltrosMobile from "./FiltrosMobile";
import DrawerForm from "./DrawerForm";
import FormTurma from "./FormTurma";
import FormDisciplina from "./FormDisciplina";

import { useFiltros } from "../FiltrosContext";

const Filtros = () => {
    //Listas
    const [edicoes, setEdicoes] = useState([]);
    const [categorias, setCategorias] = useState([]);

    const { drawerVisivel, setDrawerVisivel, drawerDisciplinaVisivel, setDrawerDisciplinaVisivel } = useFiltros();

    const carregarEdicoes = () => {
        axios({
            method: "get",
            url: "/api/gestao-turmas/lista-edicoes"
        })
            .then(response => {
                setEdicoes(response.data);
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    const carregarCategorias = () => {
        axios({
            method: "get",
            url: "/api/gestao-turmas/lista-categorias"
        })
            .then(response => {
                setCategorias(response.data);
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    useEffect(() => {
        carregarEdicoes();
        carregarCategorias();
    }, []);

    return (
        <>
            <FiltrosDesktop edicoes={edicoes} categorias={categorias} />
            <FiltrosMobile edicoes={edicoes} categorias={categorias} />
            <DrawerForm
                title="Adicionar Turma"
                subtitle="Preenche os campos abaixo para criar uma nova turma"
                visible={drawerVisivel}
                onClose={() => setDrawerVisivel(false)}
            >
                <FormTurma categorias={categorias} visivel={drawerVisivel} onClose={() => setDrawerVisivel(false)} />
            </DrawerForm>
            <DrawerForm
                title="Adicionar acompanhamento"
                subtitle="Preenche os campos abaixo para criar um novo acompanhamento"
                visible={drawerDisciplinaVisivel}
                onClose={() => setDrawerDisciplinaVisivel(false)}
            >
                <FormDisciplina
                    visivel={drawerDisciplinaVisivel}
                    onClose={() => setDrawerDisciplinaVisivel(false)}
                />
            </DrawerForm>
        </>
    );
};

export default Filtros;
